import { render } from "./AllTokensList.vue?vue&type=template&id=3aaa54bd&scoped=true"
import script from "./AllTokensList.vue?vue&type=script&lang=js"
export * from "./AllTokensList.vue?vue&type=script&lang=js"

import "./AllTokensList.vue?vue&type=style&index=0&id=3aaa54bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aaa54bd"]])

export default __exports__